module.exports = __webpack_public_path__ + "static/media/2.a8f196ae.jpg";